const OUTCOME = { done: { t: "Done", c: "#D4FF3A" }, needs_review: { t: "Needs review", c: "#FFB020" }, blocked: { t: "Blocked", c: "#FF3B5C" } };

export const Receipt = ({ r, testId, compact }) => {
  if (!r) return null;
  const o = OUTCOME[r.outcome] || OUTCOME.done;
  return (
    <div className="mt-2 rounded-md border-l-2 bg-white/[0.02] px-3 py-2" style={{ borderColor: o.c }} data-testid={testId}>
      <div className="font-mono text-[9px] uppercase tracking-[0.2em] flex gap-2"><span style={{ color: o.c }}>Receipt · {o.t}</span><span className="text-muted-foreground">{r.source}</span></div>
      <p className={`text-xs mt-1 text-foreground/90 ${compact ? "line-clamp-2" : ""}`}>{r.summary}</p>
      {!compact && (r.actions?.length > 0 || r.records?.length > 0) && (
        <div className="font-mono text-[10px] text-muted-foreground mt-1">{r.actions?.length || 0} actions · {r.records?.length || 0} records</div>
      )}
      {!compact && r.links?.map((l) => <a key={l} href={l} target="_blank" rel="noreferrer" className="block font-mono text-[10px] underline truncate text-[#00E5FF]">{l}</a>)}
    </div>
  );
};
